import { PagedRequestType } from "../../types/PagedResults";
import { JudgePhaseProjectDocumentByIdProjectType } from "../../types/ScientificModule";
import { get, post, put } from "../../utils/axios-config";
import { JUDGE_PHASE_PROJECT_DOCUMENTS, JUDGE_PHASE_PROJECT_DOCUMENTS_BY_PROJECT } from "../../utils/constants";

export const createJudgePhaseProjectDocumentByIdProject = async (data: JudgePhaseProjectDocumentByIdProjectType) => await post<JudgePhaseProjectDocumentByIdProjectType, string>(JUDGE_PHASE_PROJECT_DOCUMENTS, data);
export const updateJudgePhaseProjectDocumentByIdProject = async (data: JudgePhaseProjectDocumentByIdProjectType) => await put<JudgePhaseProjectDocumentByIdProjectType, string>(JUDGE_PHASE_PROJECT_DOCUMENTS, data);

export const getJudgePhaseProjectDocumentsByIdProject = async (data?: PagedRequestType) => {
    const url = `${JUDGE_PHASE_PROJECT_DOCUMENTS_BY_PROJECT}/${data?.IdProject}`;
    return await get<JudgePhaseProjectDocumentByIdProjectType[]>(url);
}; 